<template>
    <div class="payment_container">
        <p>有料プランは休止中です。</p>
        <!-- <h2>会員情報</h2>
        <p>プラン：月間(¥500/月)</p>
        <p style="padding-bottom:10px;">サービス登録日：{{this.createdTime}}</p>
        <p style="padding-bottom:10px;">次回更新日：{{this.endTime}}</p>
        <div v-show="!this.isTokenId" class="payment">
            <p>クレジットカード番号を入力</p>
            <div id="card-element">
            </div>
        </div>
        <div v-if="isTokenId">クレジットカードの登録はされています</div>
        <div v-if="isTokenId">
            <b-button class="is-text" size="is-small" @click="changeCard">カード情報の変更</b-button>
        </div>
        <div v-if="show_result" style="padding-bottom:10px">{{result_message}}</div>
        <div v-if="!isTokenId"><b-button class="is-info" @click="submit">登録する</b-button></div>
        <p style="padding-top:20px;">現在登録できるカードはVISAカード マスターカード アメックスです</p>
        <p><i class="fab fa-cc-visa fa-2x" style="padding-left:5px;color:#1A1F70;"></i><i class="fab fa-cc-mastercard fa-2x" style="padding-left:5px;color:#E35204;"></i><i class="fab fa-cc-amex fa-2x" style="padding-left:5px;color:#006FCF;"></i></p>
        <div class="cancel_area">
            <div v-if="subscription_id && isTokenId"><b-button @click="cancel" type="is-text">解約する</b-button></div>
            <div v-if="!subscription_id"><b-button @click="restart" type="is-text">再開する</b-button></div>
        </div> -->
    </div>
</template>

<script>
import moment from 'moment'
import firebase from 'firebase/app'
export default {
    data() {
        return {
            card: null,
            subscription_id: null,
            stripe: window.Stripe('pk_live_Y4MSNTCESEkOLAJnsyunC4tx00KsMxjn8A'),
            show_result: false,
            result_message: "",
            isTokenId: false,
            createdTime : '',
            endTime: ''
        };
    },
    computed:{
        user(){
            return this.$store.getters.user;
        }
    },
    created(){
        this.createdTime  = moment(this.$store.getters.user.metadata.creationTime).locale('ja').format('l')
        firebase.firestore().collection('stripe_customers').doc(this.user.uid).get().then((doc) =>{
            var data = doc.data()
            this.subscription_id = data.subscription_id   
        });
        firebase.firestore().collection('stripe_customers').doc(this.user.uid).collection('token').doc(this.user.uid).get().then((doc) =>{
            if(doc.data()){
                this.isTokenId = true
            }
        });
        firebase.firestore().collection('user').doc(this.user.uid).get().then((doc) =>{
            var data = doc.data()
            if(data.period_end){
                this.endTime = moment.unix(data.period_end).locale('ja').format('l')
            }
        });
    },
    mounted() {
        const title = "カード登録｜エモーションダイアリー"
        const description = "カード登録画面"
        document.title = title
        document.querySelector("meta[property='og:title']").setAttribute('content', title)
        document.querySelector("meta[name='description']").setAttribute('content', description)
        document.querySelector("meta[property='og:description']").setAttribute('content', description)
        var style = {
            base: {
                color: '#32325d',
                fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                fontSmoothing: 'antialiased',
                fontSize: '16px',
                '::placeholder': {
                color: '#aab7c4'
                }
            },
            invalid: {
                color: '#fa755a',
                iconColor: '#fa755a'
            }
    }
    const elements = this.stripe.elements();
    this.card = elements.create("card", {style: style});
    this.card.mount("#card-element");
    },
    methods: {
        submit() {
            const self = this;
            self.show_result = false;
            this.stripe.createToken(this.card).then(result => {
                console.log("result: " + JSON.stringify(result));
                // エラーの場合
                if (result.error) {
                    self.show_result = true;
                    self.result_message = result.error.message;
                // 成功の場合
                } else {
                    self.show_result = true;
                    self.result_message = result.message;
                    firebase.firestore().collection('stripe_customers').doc(this.user.uid).collection('token').doc(this.user.uid).set({
                        token_id: result.token.id,
                    },{ merge: true });
                    this.$buefy.toast.open('登録できました！')
                }
            });
        },
        cancel(){
            this.$buefy.dialog.confirm({
            message: '定期コースを解約をしますか？無料期間がある場合、残りの無料期間が失効します',
            onConfirm: () =>  
                firebase.firestore().collection('stripe_customers').doc(this.user.uid).collection('subscription_id').doc(this.user.uid).set({
                    subscription_id: null
                },{ merge: true }).then(()=>{
                    firebase.firestore().collection('user').doc(this.user.uid).set({
                        status: false
                    },{ merge: true })
                }).then(()=>{
                    this.$buefy.toast.open('解約手続きをしました');
                })
            })
        }, 
        restart(){
            this.$buefy.dialog.confirm({
            message: '定期コースを再申し込みしますか？',
            onConfirm: () =>  
                firebase.firestore().collection('stripe_customers').doc(this.user.uid).collection('subscription_id').doc(this.user.uid).set({
                    subscription_id: 'makeSubscription'
                },{ merge: true }).then(()=>{
                    this.$buefy.toast.open('Thank you!定期コースの再開をしました');
                })
            })
        },
        changeCard(){
            this.isTokenId = false
        }   
    }
};
</script>

<style scoped>
.payment_container{
    background-color: #F8F9FA;
    max-width:500px;
    margin: auto;
    padding: 20px;
}
.payment{
    padding: 20px 0 20px 0;
    
}
#card-element{
    background-color: white;
    padding: 10px;
}
.cancel_area{
    text-align: right;
    margin-top:80px;
}
</style>